import React from "react";
import { Column, Columns, Table, Title } from "@allxsmith/bestax-bulma";
import InspectionApproveRow from "./InspectionApproveRow";



export default function InspectionApproveSection({data, onChange}){

    return (
        <div>
            <Columns isMultiline>
                <Column>
                    <Title>Inspections</Title>
                </Column>
            </Columns>
            <Columns isMultiline>
                <Column>
                    <Table isFullwidth>
                        <thead>
                            <tr>
                                <th>Inspection Type</th>
                                <th>Expiry Date</th>
                                <th>Completed Date</th>
                                <th>Nex Expiry Date</th>
                                <th>New Completed Date</th>
                            </tr>
                        </thead>
                        <tbody>
                            {data.attached_inspections.map((inspection, index) => (
                                <InspectionApproveRow
                                    inspection={inspection}
                                    index={index}
                                    onChange={onChange}
                                />
                            ))}
                        </tbody>
                    </Table>
                </Column>
            </Columns>
        </div>
    );


}